import { Typography, Box, styled, Switch, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IFormPropertyGroup } from '../../models/form/form';

const ElementWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#F0F0F0',
  cursor: 'pointer',
  paddingInline: '1.3%',
  paddingBlock: '0.3%',
  marginBottom: '0.5%',
  borderRadius: 5,
  "&:hover": {
    backgroundColor: theme.palette.grey[300],
  }
}));

interface IFormPropertyGroupElementProps {
  formPropertyGroup: IFormPropertyGroup;
  onSetFormPropertyGroupActive: (formPropertyGroup: IFormPropertyGroup) => void;
  propertyGroupName: string;
}

const FormPropertyGroupElement = ({ formPropertyGroup, onSetFormPropertyGroupActive, propertyGroupName }: IFormPropertyGroupElementProps) => {
  const { t } = useTranslation(['form']);
  return (
    <ElementWrapper>
      <Box>
        <Typography display={'inline'} sx={{ fontWeight: '500', marginRight: 2 }}>
          {propertyGroupName}
        </Typography>
      </Box>

      <Box>
        <Tooltip title={t("form:activeSwitchTooltip")} placement='top' arrow><Switch checked={formPropertyGroup.isActive} onChange={() => onSetFormPropertyGroupActive(formPropertyGroup)} size='small' /></Tooltip>
      </Box>
    </ElementWrapper>
  );
}

export default FormPropertyGroupElement;
